var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.784,
    height: 13.257,
    viewBox: "0 0 15.784 13.257",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -2.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.213,9.313a2.147,2.147,0,1,0,2.868,2.868Z",
    transform: "translate(-2.26 -1.642)",
    fill: "#8c919a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.873,11.733A3.587,3.587,0,1,1,6.9,6.759L5.112,4.972A10.146,10.146,0,0,0,1,9.74s2.152,5.74,7.892,5.74a7.682,7.682,0,0,0,4.958-1.77ZM8.374,6.2a3.52,3.52,0,0,1,.518-.052A3.588,3.588,0,0,1,12.479,9.74a3.52,3.52,0,0,1-.052.518l2.461,2.461a10.578,10.578,0,0,0,1.9-2.979S14.632,4,8.892,4a7.746,7.746,0,0,0-2.356.367Z",
    transform: "translate(0 -0.141)",
    fill: "#8c919a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.166,16.227,2.97,4.03,4.03,2.97l12.2,12.2Z",
    transform: "translate(-0.706)",
    fill: "#8c919a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHide);
export default __webpack_public_path__ + "static/media/icon-hide.80d8ef99f8cb2ce3587c03f84529a5cf.svg";
export { ForwardRef as ReactComponent };